
import About from "pages/About";
import Blogs from "pages/Blogs";
import Contact from "pages/Contact";
import Features from "pages/Features";
import Home from "pages/Home";
import Privacy from "pages/Privacy";
import TermsAndConditions from "pages/TermsAndConditions";
import Blog from "crm/other/Blog";
import BlogPost from "crm/other/BlogPost";
import { Routes, Route, Navigate } from "react-router-dom";
import Industries from "pages/Industries";
import IndustryDetailTemplate from "pages/industries/IndustryDetailTemplate";
import DynamicPage from "pages/DynamicPage";

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blog />} />
            {/* FIXED ROUTE */}
            {/* <Route path="/blog/:title" element={<BlogPost />} /> */}
            {/* WARNING: The following route will match any root path not matched above. */}
            {/* <Route path=":slug" element={<BlogPost />} /> */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />
            <Route path="/:slug" element={<DynamicPage />} />
            {/* Industries Main Page */}
            <Route path="/industries" element={<Industries />} />
            {/* Industry Detail Page */}
            {/* <Route path="/industries/:industryKey" element={<IndustryDetailTemplate />} /> */}
            {/* <Route path=":industryKey" element={<IndustryDetailTemplate />} /> */}

        </Routes>

    );
}
